import { OptionsObject, SnackbarMessage, enqueueSnackbar } from 'notistack';
import { useFeatureToggleContext } from '../featureToggle/useFeatureToggleContext';
import { UICustomizationValue } from '../featureToggle/featureToggle.constants';

export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning'
}

export function useNotification() {
  const { getCustomValue } = useFeatureToggleContext();

  const disableAutoHideForError = getCustomValue(
    UICustomizationValue.InvDisableAutoHideForErrorToastMessage
  ) as boolean;

  const autoHideDuration = getCustomValue(
    UICustomizationValue.InvToastMessageAutoHideDuration
  ) as number;

  const messageTypes = getCustomValue(
    UICustomizationValue.InvToastMessageTypesWithAutoHideDuration
  ) as string[];

  function notify(message: SnackbarMessage, options: OptionsObject = {}) {
    const applyAutoHideDuration =
      autoHideDuration > 0 &&
      (!messageTypes.length || messageTypes.includes(options.variant || ''));

    return enqueueSnackbar(message, {
      persist:
        disableAutoHideForError && options.variant === NotificationType.Error,
      autoHideDuration: applyAutoHideDuration ? autoHideDuration : undefined,
      ...options,
      preventDuplicate: true
    });
  }

  function success(message: SnackbarMessage, options: OptionsObject = {}) {
    return notify(message, {
      ...options,
      variant: 'success'
    });
  }

  function error(message: SnackbarMessage, options: OptionsObject = {}) {
    return notify(message, {
      ...options,
      variant: 'error'
    });
  }

  function info(message: SnackbarMessage, options: OptionsObject = {}) {
    return notify(message, {
      ...options,
      variant: 'info'
    });
  }

  function warning(message: SnackbarMessage, options: OptionsObject = {}) {
    return notify(message, {
      ...options,
      variant: 'warning'
    });
  }

  return {
    error,
    info,
    success,
    warning
  };
}
